(function () {
  if (window.__avLuxe) return;
  window.__avLuxe = true;

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.av-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Quick add to cart -> opens Dawn cart drawer */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form.matches || !form.matches('form[data-av-add]')) return;
    ev.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = '<span>Toevoegen…</span>'; }

    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { throw new Error(res.description || res.message); }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (btn) btn.innerHTML = label;
      })
      .catch(function (err) {
        if (btn) { btn.innerHTML = '<span>' + (err && err.message ? err.message : 'Probeer opnieuw') + '</span>'; }
        setTimeout(function () { if (btn) btn.innerHTML = label; }, 2600);
      })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* Hero video play/pause */
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-av-video-toggle]');
    if (!t) return;
    var hero = t.closest('.av-hero');
    var vids = hero.querySelectorAll('video');
    var paused = t.getAttribute('aria-pressed') === 'true';
    vids.forEach(function (v) { paused ? v.play() : v.pause(); });
    t.setAttribute('aria-pressed', paused ? 'false' : 'true');
    t.setAttribute('aria-label', paused ? 'Video pauzeren' : 'Video afspelen');
    t.querySelector('.av-i-pause').style.display = paused ? '' : 'none';
    t.querySelector('.av-i-play').style.display = paused ? 'none' : '';
  });

  /* Muted autoplay + loop, also on iOS */
  function kickVideos() {
    document.querySelectorAll('.av-hero video').forEach(function (v) {
      v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      v.removeAttribute('controls');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function boot() { initReveal(); kickVideos(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); kickVideos(); });
})();
